import { gql } from '@apollo/client'

export const CLOSING_TYPES_QUERY = gql`
  query closingTypes($sortBy: ClosingTypeSort, $filter: ClosingTypeFilter) {
    closingTypes(sortBy: $sortBy, filter: $filter) {
      collection {
        id
        title
      }
    }
  }
`
